import { useEffect } from 'react';
/**
 * Scroll to the bottom of the chat when it is visited
 */
export const useScrollToBottom = containerRef => {
    const scrollToContainer = () => {
        setTimeout(() => {
            if (containerRef) {
                containerRef.scrollTo({
                    top: containerRef.scrollHeight,
                    behavior: 'smooth',
                });
            }
        }, 1250);
    };

    useEffect(() => {
        scrollToContainer();
    }, [containerRef]);

    return scrollToContainer;
};
